import employee from '@/api/hr/employee'
import statusReason from '@/api/hr/employee-status-reason'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: [],
  positions: [],
  status: [],
  shifts: [],
  pcDates: [],
  paymentTypes: [],
  nationalities: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_POSITION(state, positions) {
    state.positions = positions
  },
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_STATUS(state, data) {
    state.status = data
  },
  SET_SHIFTS(state, data) {
    state.shifts = data
  },
  SET_PC_DATES(state, data) {
    state.pcDates = data
  },
  SET_PAYMENT_TYPES(state, data) {
    state.paymentTypes = data
  },
  SET_NATIONALITY(state, data) {
    state.nationalities = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return employee.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return employee.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await employee.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  update(context, data) {
    return employee.update(data)
  },

  delete(context, id) {
    return employee.destroy(id)
  },

  getStatusReason(context, attributes = {}) {
    return statusReason.get({ params: attributes })
  },
  async photoUpload(context, data) {
    return await employee.photoUpload(data)
  },

  async printCard(context, data) {
    return await employee.printCard(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.positions.length > 0) {
      let response = await employee.getPosition()
      context.commit('SET_POSITION', response.data)
    }
    if (!context.state.status.length > 0) {
      let response = await employee.getStatus()
      context.commit('SET_STATUS', response.data)
    }
    if (!context.state.shifts.length > 0) {
      let response = await employee.getShift()
      context.commit('SET_SHIFTS', response.data)
    }
    if (!context.state.pcDates.length > 0) {
      let response = await employee.getPcDate()
      context.commit('SET_PC_DATES', response.data)
    }
    if (!context.state.paymentTypes.length > 0) {
      let response = await employee.getPaymentType()
      context.commit('SET_PAYMENT_TYPES', response.data)
    }
    if (!context.state.nationalities.length > 0) {
      let response = await employee.getNationality()
      context.commit('SET_NATIONALITY', response.data)
    }
  }
}
